import axiosInstance from '../../../../../../utils/axios';
import { ROLE } from '../../../../../../utils/Constants';

const path = 'cashier/sales/bulk-settlement';
const options = { role: ROLE.CASHIER } as any;

export type BulkSettlementTransactionOrderedItemPayload = {
  menu_item_id: string;
  quantity: number;
};

export type BulkSettlementTransactionBulkItemPayload = {
  name: string;
  total: number;
};

export type BulkSettlementTransactionPayload = {
  operation_id?: string | null;
  sale_time: string;
  cashier_id: string;
  payment_method: 'cash' | 'card' | 'other';
  payment_method_id?: string | null;
  method_name?: string | null;
  number_of_persons: number;
  received_amount: number;
  comment?: string | null;
  item_type: 'menu_item' | 'bulk_item';
  ordered_items: BulkSettlementTransactionOrderedItemPayload[];
  bulk_item?: BulkSettlementTransactionBulkItemPayload | null;
};

export type CreateBulkSettlementTransactionsPayload = {
  business_date: string;
  table_id: string;
  transactions: BulkSettlementTransactionPayload[];
};

export const getBulkSettlementTableList = async (): Promise<any> =>
  axiosInstance(options).get(`${path}/table-list`);

export const settleBulkSettlementTable = async (
  values: CreateBulkSettlementTransactionsPayload,
): Promise<any> => {
  const response: any = await axiosInstance(options).post(`${path}/settle-table`, values);
  if (response?.success === false) {
    const firstErrorCode: string | undefined = response?.error?.[0]?.msg;
    throw new Error(firstErrorCode || response?.message || 'Bulk settlement request failed');
  }
  return response;
};
